<template>
    <div class="card-content">
        <div class="card-content-name">
        <div class></div>
        <div class="card-content-rank"></div>
        </div>
        <div class="card-content-price"></div>
        <div class="card-stats">
        <div :key="stat" v-for="stat in stats" class="card-content-stats">
            <div class="card-content-stats-time">
            <div :key="line" v-for="line in lines" class="empty-time"></div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "skeletonCard",
  data: function() {
    return {
        lines: {
            default: 1
        },
        stats: {
            default: 3
        }
    }
  }
}  
</script>

<style lang="sass">
</style>


// WEBPACK FOOTER //
// src/components/SkeletonCard.vue